import React from "react";

function PlanSummary({ plan }) {
  if (!plan) {
    return (
      <div className="panel">
        <h3 className="section-title">Plans &amp; pricing</h3>
        <p className="muted">Choose a plan to enable deployments, agent hosting, and analytics logging.</p>
      </div>
    );
  }

  return (
    <div className="panel">
      <div className="section-header">
        <h3 className="section-title">Current plan</h3>
        <div className="badge">{`${plan.name} · ${plan.monthlyCredits} credits/month`}</div>
      </div>
      <p className="muted">Need some new copy here. TODO</p>
      <div className="chips" style={{ marginTop: "12px" }}>
        <span className="chip">{plan.llmModel}</span>
        <span className="chip">{`${plan.maxApps} saved apps`}</span>
        <span className="chip">{`${plan.maxSnapshots} exports`}</span>
      </div>
    </div>
  );
}

export default PlanSummary;
